// Version of the WhatsApp-notifications consent disclosure. Written to the
// user document (`waConsentVersion`) every time the user accepts the consent
// modal in Settings → Notifications, so we can detect users who consented
// under an older version and prompt them to re-accept.
//
// BUMP THIS when the disclosure text or the WhatsApp message template
// changes in a way that affects WHAT is transmitted or TO WHOM:
//   - Message template starts including plate / location / event details
//     inline instead of just a link
//   - A new recipient (beyond Meta) enters the data-sharing chain
//   - The consent modal body materially changes what the user is agreeing to
//
// Do NOT bump for:
//   - Cosmetic wording tweaks, typo fixes, translations of existing meaning
//   - Layout / styling changes to the modal
//   - Unrelated legal-doc updates that don't touch the WA flow
export const WA_CONSENT_VERSION = 1;
